import React from 'react';
import type { CheckboxGroupProps } from './Checkbox.props';
import Checkbox from './Checkbox';
import { Box } from '../Box';

const CheckboxGroup = <T,>({ values, onChange, options, direction = 'row' }: CheckboxGroupProps<T>) => {

  const handleChange = (val: T) => {
    if (values.includes(val)) {
      onChange(values.filter(v => v !== val));
    } else {
      onChange([...values, val]);
    }
  };

  const isChecked = (val: T): boolean => {
    if (!val) return false;

    return values.includes(val);
  };

  return (
    <Box width='100%' flexDirection={direction} display='flex' gap={40} className='custom-checkbox-group'>
      {options.map((option, index) => (
        <Checkbox
          key={index}
          label={option.label}
          value={isChecked(option.value)}
          onChange={() => handleChange(option.value)}
        />
      ))}
    </Box>
  );
};

export default CheckboxGroup;
